import React from 'react'
import { Outlet } from 'react-router-dom'

export default function LayoutLanding() {
  return (
    <div className="layout-root relative flex min-h-screen flex-col">
      <main className="flex-1">
        <Outlet />
      </main>
    </div>
  )
}
